module.exports = __webpack_public_path__ + "static/media/Dily_za_zahradou.d670ec81.md";